import { render, staticRenderFns } from "./V_Ongoing_OpenMap_LastRiddles.vue?vue&type=template&id=1f0a5069&scoped=true&"
import script from "./V_Ongoing_OpenMap_LastRiddles.vue?vue&type=script&lang=js&"
export * from "./V_Ongoing_OpenMap_LastRiddles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f0a5069",
  null
  
)

export default component.exports